import { captureException } from '@sentry/react'
import { z } from 'zod'
import axios from '@/axios-instance-node'
import { NeighborhoodWithSubGeoSchema } from '@/features/subgeo/types.ts'
import { parseResponseData } from '@/helpers/utils'
import type { ResponseType } from '@/types.ts'

export interface HttpAddNeighborhoodsToSubgeoParams {
	urlParams: {
		id: string
	}
	payload: {
		neighborhoodIds: string[]
	}
	params: {
		responseType: ResponseType
	}
}

const AddNeighborhoodsResponseSchema = z.array(NeighborhoodWithSubGeoSchema)

export const httpAddNeighborhoodsToSubgeo = async ({
	urlParams,
	payload,
	params
}: HttpAddNeighborhoodsToSubgeoParams) => {
	const response = await axios.put(
		`/v1/geo-mapping-sub-geos/${urlParams.id}/add-neighborhoods`,
		payload,
		{
			params
		}
	)

	return parseResponseData({
		responseData: response.data,
		responseShape: AddNeighborhoodsResponseSchema,
		onZodError: captureException
	})
}
